// NOTE TO AUDREY: Yo wassup we need to add a section for pronouns, Fav Video Game, Portfolio, and Social Media
//reply note: yup working on it, n following taylors design, but idk how feasible adding inventory images would be, will bloat the site

const Team = [
  {
    time: "11/12/2025 13:51:23",
    email: "gracewelch@boundlessgamers.org",
    name: "Grace Welch",
    nickname: "",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1FNL_XX9YkqD6nIuHxmYngxc_RapqwbSq",
    team: "Production, Development",
    role: "Team 1 - Game/Level Designer & Prototype Developer",
    game: "The Elder Scrolls IV: Oblivion",
    fact: "Lost only one point on the Full Sail University Global Professionalism Score because I slept in on a Zoom meeting.",
    items: "The Ocarina of Time & the Chillrend Sword",
    portfolio: "https://www.artstation.com/grace_welch",
    github: "",
    linkedin: "https://www.linkedin.com/in/grace-welch-79a626347",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 14:40:52",
    email: "anjaligali@boundlessgamers.org",
    name: "Anjali Gali",
    nickname: "",
    pronouns: "she/her/hers",
    photo: "https://drive.google.com/thumbnail?id=1XafR38xOOCCRKIdkHdnREV5Q-fphjbr2",
    team: "Art, Web Design",
    role: "Team 3 - Character & Environment Artist, Team 5 - Web Designer, Programmer, UI/UX Developer",
    game: "Life is Strange",
    fact: "I used to be a teacher!",
    items: "Healing Potion, Food",
    portfolio: "https://anjaligali.framer.website/",
    github: "https://github.com/aglia-iu",
    linkedin: "https://www.linkedin.com/in/anjaligali/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 14:46:32",
    email: "emmapuissegur@boundlessgamers.org",
    name: "Emma Puissegur",
    nickname: "EmaShane",
    pronouns: "she/her",
    photo: "https://drive.google.com/thumbnail?id=1YWUXKOOJ3e_kRMzc9PFefc7gk6jlozIe",
    team: "Audio",
    role: "Team 4 -  Audio Engineer, Composer",
    game: "Kingdom Hearts 2",
    fact: "I've been a flute player and a singer for almost 15 years",
    items: "Crowbar and a Magical Gemstone",
    portfolio: "https://drive.google.com/drive/folders/1fwDuPJ6Wv4G5okoPZZe6seRV0IrbzH36?usp=drive_link",
    github: "",
    linkedin: "https://www.linkedin.com/in/emma-puissegur-925154224/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 16:20:12",
    email: "zack.eddy@boundlessgamers.org",
    name: "Zack Eddy",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=16wVNWAn9cq7g-Dz63V7uuBuShXFHJym7",
    team: "Production Support, Development",
    role: "Team 9 /Team 1 - Animator/3D Artist",
    game: "Legend of Zelda: Windwaker",
    fact: "I'm a black belt in Tae Kwon Do, and world class marching Cymbalist",
    items: "Probably a Hookshot, and a Pip-boy.",
    portfolio: "https://www.artstation.com/zackeddy21",
    github: "https://github.com/ZackaryEddy",
    linkedin: "https://www.linkedin.com/in/zackeddy",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 16:46:48",
    email: "sapphirap@boundlessgamers.org",
    name: "Sapphira Pack",
    nickname: "",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1xwS_vDnclvl7R7zj2MzN3izSrbawci96",
    team: "Art",
    role: "Team 1 - Team Assistant\nTeam 2 - Team Assistant\nTeam 3 - Team Assistant",
    game: "Final Fantasy 14 and Persona 5 Royal",
    fact: "I do some streaming on Twitch as a VTuber.",
    items: "Flashlight and some teriyaki jerky",
    portfolio: "",
    github: "",
    linkedin: "",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 16:55:28",
    email: "rachaelautting@boundlessgamers.org",
    name: "Rachael Utting",
    nickname: "RivaHakushia",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1KEeElrnl5MtijLwhS8W7Ils4TUyFImG1",
    team: "Art",
    role: "Team 3 - Concept Artist. Character Artist",
    game: "Monkey Island 2: Le Chuck's Revenge",
    fact: "Arrived at Rachael's second cousin's 21st formal dress party with her Cousin both dressed as pirates, when asked \"why are you dressed as pirates\" Their response was \"Because we Arrrrrr!",
    items: "Bag of Holding and Murray the Skull",
    portfolio: "https://www.deviantart.com/riva-hakushia",
    github: "",
    linkedin: "https://www.linkedin.com/in/rachael-utting-94976435b/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 19:46:04",
    email: "johnny.hao@boundlessgamers.org",
    name: "Johnny Hao",
    nickname: "Johnny",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1Lh_CVcbWZ27W2acggltPy3hA_l-t_evf",
    team: "Art",
    role: "Team 2 - 3D Artist",
    game: "Honor of Kings",
    fact: "Big fan of mobile games!",
    items: "A gun and a knife.",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/johnny-hao-417419345/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 20:26:52",
    email: "grahamstonejohnson@boundlessgamers.org",
    name: "Graham Stone Johnson",
    nickname: "",
    pronouns: "he/him",
    photo: "https://drive.google.com/thumbnail?id=14u3d8y0Nq5uYbM2BVbA-gbdmrjSwmlxs",
    team: "Writing",
    role: "Team 5 - Co-Lead Writer",
    game: "The Uncharted Series",
    fact: "I have a brick from the chimney and a piece of tin from the roof of the cabin where Evil Dead (1981) was filmed, and I'm not at liberty to reveal how I procured them.",
    items: "Something providing me with the ability to fly, be it magical or mechanical, and a healing potion/med kit.",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/graham-johnson-328976187/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 21:21:31",
    email: "dthomas@boundlessgamers.org",
    name: "David Thomas",
    nickname: "Pixel",
    pronouns: "The dumb one",
    photo: "https://drive.google.com/thumbnail?id=1lMEK6J_sGYKlmIbfEamGauFL-4SfRLAA",
    team: "Development",
    role: "1-10 Directing Manager",
    game: "Call of Duty, Battlefield, Assassin’s Creed",
    fact: "I’m not fun",
    items: "Everything",
    portfolio: "",
    github: "",
    linkedin: "",
    xbox: "PixelPirate1912",
    playstation: "PixelPirate1912"
  },
  {
    time: "11/12/2025 21:57:37",
    email: "ben.molenaar@boundlessgamers.org",
    name: "Ben Molenaar",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1KKtS3qupLdwtstLqj5D2MjKlMoof4ejg",
    team: "Production Support, Development",
    role: "Team 9 (Supporting Team 2 currently) - Programmer",
    game: "Dark Souls",
    fact: "I own 2 beautiful Golden Retrievers, Billie & Honey",
    items: "Jetpack, Med-Kit (for when I crash my jetpack)",
    portfolio: "https://benmolenaar96.wixsite.com/benmolenaar",
    github: "",
    linkedin: "https://www.linkedin.com/in/benjamin-molenaar-0a1775170/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/12/2025 23:01:56",
    email: "rabusarah@boundlessgamers.org",
    name: "Rania Abu Sara",
    nickname: "Ran",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1ZOUIfnakLdciP7fvOlQ1YLfLAB5GHDTR",
    team: "Development",
    role: "Fundraiser",
    game: "Final Fantasy VII (PS1)",
    fact: "The first game I have ever completed was FFVII on the PS1; feels like home.",
    items: "Knights of Round Materia & Lady Maria's Rakuyo",
    portfolio: "",
    github: "",
    linkedin: "",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 0:55:39",
    email: "mikep@boundlessgamers.org",
    name: "Mike Pasqualicchio",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1pp-WmPLu2B4ybFSvhA0J3qv-pZusX795",
    team: "Production, Writing, Actors, Production Support",
    role: "Production: Project Manager and Operational Support\n\nWriting: Story Framework Development, Co-Writer Support, and Narrative Consultant\n\nActors: Voice/Talent for In-Game Character",
    game: "Donkey Kong Country 2: Diddy's Kong Quest",
    fact: "Mike is currently working on a new novel adaptation of H.G. Wells' classic, The Time Machine. He plans to release this complete work for free for everyone to read in the future.",
    items: "A roll of toilet paper and a laser sword.",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/mike-pasqualicchio-027b68317/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 16:41:10",
    email: "meganswaine@boundlessgamers.org",
    name: "Megan Swaine",
    nickname: "",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1iQ7BngHPwY10Lvr8qEy32KlJuSt-D2LE",
    team: "Writing",
    role: "Team 5 - Dialog Writer",
    game: "Maniac Mansion",
    fact: "The first game I ever wrote for was a flip-phone game that had to be under 500k.",
    items: "Bag of Holding, Ring of Invisibility",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/megswaine/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 21:06:19",
    email: "justin.mg@boundlessgamers.org",
    name: "Justin Makela-Guerrero",
    nickname: "Barry Rylan",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1ND0-bSjZ01Bc7SaXeYXps6eArYqibnTc",
    team: "Art",
    role: "3D artist and animator",
    game: "Monster Hunter Series",
    fact: "I'll never remember your name hearing it the first time, but I will recall a very minute detail about instantly like your favorite lunch meat! (I see you ham lovers)",
    items: "I would want a very good great sword and a decanter of endless health potion",
    portfolio: "https://www.artstation.com/barryrylan_art",
    github: "",
    linkedin: "https://www.linkedin.com/in/justin-rylan-makela-guerrero-026140165/",
    xbox: "",
    playstation: "cryostatic101"
  },
  {
    time: "11/13/2025 21:54:55",
    email: "drewturner@boundlessgamers.org",
    name: "Drew Turner",
    nickname: "",
    pronouns: "He / Him",
    photo: "https://drive.google.com/thumbnail?id=1BA3zj8qqNjn8VW1mFjLtfa0ei-q0NaXs",
    team: "Development",
    role: "Team 1 - Developer",
    game: "Mother 3",
    fact: "I have 2 half blue eyes",
    items: "Two really cool pairs of sunglasses (in case the first pair breaks)",
    portfolio: "tinyurl.com/drewturnerart",
    github: "",
    linkedin: "https://www.linkedin.com/in/drew-turner-19aa0b35a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 22:08:37",
    email: "recnepsnagam@boundlessgamers.org",
    name: "Spencer Magan",
    nickname: "",
    pronouns: "he/him",
    photo: "https://drive.google.com/thumbnail?id=1oWqo25MC1ZJ0UP6iVdM450d_CjGoFVa4",
    team: "Audio",
    role: "Team 4 - Music Composition, Sound Design",
    game: "Chicory: A Colorful Tale",
    fact: "I once made some music from the sound of curdled milk being dumped into the sink.",
    items: "Bustling Fungus and Snecko Eye",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/spencer-magan-70ab6437a/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 22:49:08",
    email: "williamoverbey@boundlessgamers.org",
    name: "William Overbey",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1c5vZ3SFm3EKgwE3Yy9qrmRIOTG1i3V7b",
    team: "Art",
    role: "Team 2 - 3D Artist",
    game: "League of Legends",
    fact: "I can juggle!",
    items: "A spell book and plenty of health potions!",
    portfolio: "https://william_overbey.artstation.com/",
    github: "",
    linkedin: "https://www.linkedin.com/in/william-overbey/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/13/2025 22:53:08",
    email: "nathaniel.pantano@boundlessgamers.org",
    name: "Nathan Pantano",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1ye5RkHsDcHa_qeIQKZ_RrT8F5IQ57kj-",
    team: "IT",
    role: "Team 2 - IT Administrator",
    game: "The Legend of Zelda Windwaker",
    fact: "I am the drummer in a band I started called SoundCage",
    items: "Blades of Chaos & Portal Gun",
    portfolio: "",
    github: "",
    linkedin: "https://www.linkedin.com/in/nathanpantano",
    xbox: "",
    playstation: "NateNater27np"
  },
  {
    time: "11/14/2025 0:40:15",
    email: "laynegish@boundlessgamers.org",
    name: "Elaina Gish",
    nickname: "Layne",
    pronouns: "",
    photo: "https://drive.google.com/thumbnail?id=1W-ig9E228u_fPLkSsVnQ6rzB78BizxyY",
    team: "Art, Writing",
    role: "Team 3 - Team Lead, Concept Artist, Team 5 - Character Interaction Writer",
    game: "Dishonored",
    fact: "I have a life-sized coffin decoration in the corner of my room.",
    items: "Chapstick, Bottled Tea",
    portfolio: "https://laynegish-writer.my.canva.site/",
    github: "",
    linkedin: "https://www.linkedin.com/in/layne-gish/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/14/2025 9:02:37",
    email: "nicholasdpalmer@boundlessgamers.org",
    name: "Nicholas Palmer",
    nickname: "Nick",
    pronouns: "He/him",
    photo: "https://drive.google.com/thumbnail?id=1aePwPWFpuPIM8PDYHnVGgCKU478z1wVo",
    team: "Audio",
    role: "Team 4 - composer, SFX",
    game: "The Last Guardian",
    fact: "I love traveling in Europe!",
    items: "Health potion, summoning charm",
    portfolio: "www.soundcloud.com/nicholas-palmer-4",
    github: "",
    linkedin: "",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/14/2025 15:51:51",
    email: "alex.easter@boundlessgamers.org",
    name: "Alex Easter",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1eKz_IferLI0c_REmpMhC5xXReRe7icMI",
    team: "Art",
    role: "Team 1 - 3D Artist",
    game: "Half-Life 2",
    fact: "I almost crashed a sail boat during a tack by wrapping counter clockwise instead of clockwise (ALMOST).",
    items: "A portal gun and an Estus flask.",
    portfolio: "https://www.artstation.com/alex_easter",
    github: "",
    linkedin: "https://www.linkedin.com/in/alexander-easter/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/14/2025 17:33:45",
    email: "jp.garcia@boundlessgamers.org",
    name: "Jean Pierre Garcia",
    nickname: "Its pierre",
    pronouns: "he",
    photo: "https://drive.google.com/thumbnail?id=1-9ilysE4inhyHpcfYPNfCzTLAejroFoy",
    team: "Art",
    role: "Team 2 3D Modeler/ Hard surface artist",
    game: "Victoria 3",
    fact: "i reached Masters in League of legends 3 times",
    items: "map and food",
    portfolio: "https://j_pierre.artstation.com",
    github: "",
    linkedin: "https://www.linkedin.com/in/jean-p-garcía",
    xbox: "",
    playstation: "Nomad_Pierre"
  },
  {
    time: "11/14/2025 19:27:59",
    email: "matthewadams@boundlessgamers.org",
    name: "Matthew Adams",
    nickname: "",
    pronouns: "he/him",
    photo: "https://drive.google.com/thumbnail?id=1hZmFfwaTs8fx9kghUeWFQ7gNdYlrTH6y",
    team: "Writing",
    role: "Team 5 - Team Lead",
    game: "The Legend of Zelda: Breath of the Wild",
    fact: "I paid off my student loans by winning a Natty Light-sponsored video competition.",
    items: "Burrito; The Magnificent Ambersons: Director's Cut (4K Blu-ray)",
    portfolio: "",
    github: "",
    linkedin: "www.linkedin.com/in/matthewadamswrites",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/14/2025 20:44:01",
    email: "morgan.holmes@boundlessgamers.org",
    name: "Morgan Holmes",
    nickname: "",
    pronouns: "She/Her",
    photo: "https://drive.google.com/thumbnail?id=1sPv5fPVeHk7Wx4A5k5S0iDQFmAuV7lMt",
    team: "Art",
    role: "3D Environment & Prop Artist",
    game: "Little Nightmares",
    fact: "I absolutely love training aerial silks in my spare time — it’s where I feel free and powerful.",
    items: "A boundless book and a bottomless brew — pure cozy magic.",
    portfolio: "morganholmes9.artstation.com",
    github: "",
    linkedin: "www.linkedin.com/in/morgan-holmes-597b8b149",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/15/2025 15:14:37",
    email: "trey.m.owens@boundlessgamers.org",
    name: "Trey Owens",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1Dzhw7_-2bRk4oXkhqgtD-Gl4Q9djQiJh",
    team: "Development",
    role: "Team 1 - Level Designer, System Designer",
    game: "The Elder Scrolls V: Skyrim",
    fact: "I have spent 10 years working in Youth Development.",
    items: "Bow (with arrows), Master Ball",
    portfolio: "https://www.artstation.com/treymowens",
    github: "",
    linkedin: "https://www.linkedin.com/in/trey-owens-22b640320/",
    xbox: "KingMrTrey",
    playstation: "KingMrTrey"
  },
  {
    time: "11/15/2025 17:11:34",
    email: "bradleydonahue@boundlessgamers.org",
    name: "Bradley Donahue",
    nickname: "Near/Far",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1sanbbDLTPVTeqO-6kt7QSFCa28tt5_o-",
    team: "Audio",
    role: "Team 4 - Audio -  Sound Designer & Composer",
    game: "Legend of Zelda",
    fact: "former e-sports sweat & shoutcaster",
    items: "Gravity Gun, Grappling hook",
    portfolio: "https://www.nearfaraudio.com/",
    github: "",
    linkedin: "https://www.linkedin.com/in/bradley-donahue/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/17/2025 15:18:25",
    email: "tylerhughes117@boundlessgamers.org",
    name: "Tyler Hughes",
    nickname: "",
    pronouns: "He/Him",
    photo: "https://drive.google.com/thumbnail?id=1mwaj8O1_YOAKr8Nkq2dx6Gu-vmIdEV-O",
    team: "Art",
    role: "Team 1 - Animator",
    game: "Hyper Light Drifter",
    fact: "My other car is a MAD-3R",
    items: "Cool helmet, Big gun",
    portfolio: "https://www.tylerehughes.com/",
    github: "",
    linkedin: "",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/19/2025 0:17:08",
    email: "taylorkephart@boundlessgamers.org",
    name: "Taylor Kephart",
    nickname: "",
    pronouns: "they/she",
    photo: "https://drive.google.com/thumbnail?id=1xkX-6epSsTUArBUSV_YngkEXtOiUkKCH",
    team: "Art, Web Design",
    role: "Team 3 - Concept Artist, Team 7 - Graphic/Visual Designer",
    game: "Baldur's Gate 3",
    fact: "Even though digital art/graphic design is my career, I love making things by hand—from trinkets and décor to an occasional DIY furniture build!",
    items: "A Grimoire/Book of Spells, and an Enchanted Dagger",
    portfolio: "https://taylorshea011.wixsite.com/design",
    github: "",
    linkedin: "https://www.linkedin.com/in/taylor-kephart/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/24/2025 12:39:28",
    email: "corey.kapellas@boundlessgamers.org",
    name: "Corey Kapellas",
    nickname: "",
    pronouns: "he/him",
    photo: "https://drive.google.com/thumbnail?id=1s0PzHmtI1dC94K5xneSYlDMTNzcf_Vwt",
    team: "Art",
    role: "Team 1 - 3D Artist, 3D Modeling",
    game: "Disco Elysium",
    fact: "Spent a decade building public art installations",
    items: "Health Potion, Charisma Buff",
    portfolio: "https://coreykapellas.com/",
    github: "",
    linkedin: "https://www.linkedin.com/in/corey-kapellas/",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/25/2025 16:51:36",
    email: "ileysarap@boundlessgamers.org",
    name: "Sara Iley",
    nickname: "",
    pronouns: "she/her/hers",
    photo: "https://drive.google.com/thumbnail?id=1PUaGXnYNutKpwd3TnqPubHHLoCe4Wman",
    team: "Fundraising/Social Media",
    role: "Team 8 - Fundraising Specialist, Social Media Specialist",
    game: "Mario Kart 64",
    fact: "I've been an ordained minister for over 6 years",
    items: "a Bag of Holding and a knife",
    portfolio: "",
    github: "",
    linkedin: "www.linkedin.com/in/sara-iley-956998151",
    xbox: "",
    playstation: ""
  },
  {
    time: "11/29/2025 15:15:35",
    email: "zachcaylor94@gmail.com",
    name: "Zachariah Caylor",
    nickname: "",
    pronouns: "he/him",
    photo: "https://drive.google.com/thumbnail?id=1CyDVfKIEUKFsW4N2ghzJBYy6uJhHMQaQ",
    team: "Writing",
    role: "Team 5- Writer, Side Quests",
    game: "Halo",
    fact: "Mentored in writing by Dan Jolley, creator of the second Firestorm from DC Comics.",
    items: "Master Sword, Deadrising OJ",
    portfolio: "https://zcaylor.wixsite.com/caylorcosmos",
    github: "",
    linkedin: "www.linkedin.com/in/zachariahcaylor",
    xbox: "ZDOG51",
    playstation: "ZuluDelta51"
  }
]

export default Team;